import { css } from '@emotion/css';

export const dateRangePopoverStyle = css({
  display: 'flex',
  flexDirection: 'column',
  background: 'var(--affine-background-overlay-panel-color)',
  borderRadius: '8px',
  boxShadow: 'var(--affine-popover-shadow)',
  overflow: 'hidden',
});

export const dateRangeFooterStyle = css({
  display: 'flex',
  padding: '8px 16px',
  gap: '16px',
  borderTop: '1px solid var(--affine-border-color)',
});

export const dateRangeMobileFooterStyle = css({
  display: 'flex',
  padding: '12px 16px',
  gap: '24px',
  borderTop: '1px solid var(--affine-border-color)',
});

export const dateRangeToggleStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: '4px',
  fontSize: '12px',
  cursor: 'pointer',
});

export const dateRangeMobileToggleStyle = css({
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
  fontSize: '14px',
  cursor: 'pointer',
});

export const dateRangeMobilePickerStyle = css({
  padding: '12px',
  backgroundColor: 'var(--layer-background-primary)',
  borderRadius: '12px',
  display: 'flex',
  flexDirection: 'column',
});
